import React from "react";
import ReactLoading from "react-loading";

const Loading = (props) => {
  return <ReactLoading type="bubbles" color="black" width={32} height={32} />;
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js